import * as ActionTypes from './types.action';

export const showServerErrorAlert = error => ({
  type: ActionTypes.SET_SERVER_ERROR,
  error
});

export const setFulfillmentError = error => ({
  type: ActionTypes.SET_FULFILLMENT_ERROR,
  error
});

export const showItemErrorAlert = error => ({
  type: ActionTypes.SET_ITEM_ERROR,
  error
});

export const showPaymentErrorAlert = error => ({
  type: ActionTypes.SET_PAYMENT_ERROR,
  error
});



// WEBPACK FOOTER //
// ./actions/error.action.js